export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/** The `error.status` codes api-v2 puts in its error envelope that the dashboard reacts to. */
export const API_V2_ERROR_STATUS = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  DASHBOARD_ACCESS_DENIED: 'DASHBOARD_ACCESS_DENIED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
} as const;
